var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.itemClassList,
      attrs: { "data-qa": `backer-center-payments-list-item:${_vm.paymentID}` },
    },
    [
      _c(
        "div",
        { staticClass: "_flexcol" },
        [
          _c("backer-center-header", {
            scopedSlots: _vm._u([
              {
                key: "prefix",
                fn: function () {
                  return [
                    _c("backer-center-thumbnail", {
                      attrs: {
                        url: _vm.yourPledgeUrl,
                        "image-url": _vm.projectImageUrl,
                        name: _vm.name,
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function () {
                  return [
                    _c("base-text", { attrs: { as: "div", level: "b1" } }, [
                      _c(
                        "a",
                        { attrs: { href: _vm.yourPledgeUrl, title: _vm.name } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.name) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "base-text",
                      {
                        staticClass: "_tc--light",
                        attrs: { as: "div", level: "caption" },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.summary) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "suffix",
                fn: function () {
                  return [
                    _c(
                      "base-text",
                      {
                        class: _vm.amountClasses,
                        attrs: {
                          level: "b1",
                          "data-qa":
                            "backer-center-payments-list-item-data:Amount",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.formattedAmount) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }